export default {

  dbh_country_cn: 'China',
  dbh_country_tw: 'Taiwan, China',
  dbh_country_mo: 'Macau, China',
  dbh_country_hk: 'Hong Kong, China',
  dbh_country_dk: 'Denmark',
  dbh_country_uy: 'Uruguay',
  dbh_country_ye: 'Yemen',
  dbh_country_il: 'Israel',
  dbh_country_iq: 'Iraq',
  dbh_country_ru: 'Russia',
  dbh_country_cd: 'DR Congo',
  dbh_country_ly: 'Libya',
  dbh_country_ca: 'Canada',
  dbh_country_hu: 'Hungary',
  dbh_country_za: 'South Africa',
  dbh_country_qa: 'Qatar',
  dbh_country_in: 'India',
  dbh_country_id: 'Indonesia',
  dbh_country_ec: 'Ecuador',
  dbh_country_sy: 'Syria',
  dbh_country_co: 'Colombia',
  dbh_country_tr: 'Turkey',
  dbh_country_eg: 'Egypt',
  dbh_country_mx: 'Mexico',
  dbh_country_at: 'Austria',
  dbh_country_bd: 'Bengal',
  dbh_country_ng: 'Nigeria',
  dbh_country_pk: 'Pakistan',
  dbh_country_py: 'Paraguay',
  dbh_country_bh: 'Bahrain',
  dbh_country_br: 'Brazil',
  dbh_country_gr: 'Greece',
  dbh_country_de: 'Germany',
  dbh_country_it: 'Italy',
  dbh_country_cz: 'Czech Republic',
  dbh_country_ma: 'Morocco',
  dbh_country_sg: 'Singapore',
  dbh_country_nz: 'New Zealand',
  dbh_country_jp: 'Japan',
  dbh_country_cl: 'Chile',
  dbh_country_sa: 'Saudi Arabia',
  dbh_country_fr: 'France',
  dbh_country_pl: 'Poland',
  dbh_country_th: 'Thailand',
  dbh_country_au: 'Australia',
  dbh_country_ie: 'Ireland',
  dbh_country_bo: 'Bolivia',
  dbh_country_se: 'Sweden',
  dbh_country_ch: 'Switzerland',
  dbh_country_kw: 'Kuwait',
  dbh_country_pe: 'Peru',
  dbh_country_tn: 'Tunisia',
  dbh_country_jo: 'Jordan',
  dbh_country_us: 'United States',
  dbh_country_fi: 'Finland',
  dbh_country_gb: 'United Kingdom',
  dbh_country_nl: 'Netherlands',
  dbh_country_ph: 'Philippines',
  dbh_country_sv: 'El Salvador',
  dbh_country_pt: 'Portugal',
  dbh_country_es: 'Spain',
  dbh_country_vn: 'Vietnam',
  dbh_country_dz: 'Algeria',
  dbh_country_om: 'Oman',
  dbh_country_ar: 'Argentina',
  dbh_country_ae: 'United Arab Emirates',
  dbh_country_kr: 'South Korea',
  dbh_country_my: 'Malaysia',
  dbh_country_lb: 'Lebanon',


}